import { countries } from 'shared/data/siteSettings';

type Country = {
  country: string;
  countryCode: string;
};

const sortCountries = (countries: Country[]) => {
  return countries?.sort((a, b) => a?.country?.localeCompare(b?.country));
};

const nonEuCountries = ['GB'];

const euCountries = () => {
  return countries
    .filter((country) => !nonEuCountries.includes(country.countryCode))
    .map((country) => country.countryCode);
};

export { sortCountries, euCountries };
